export default "__VITE_ASSET__e72413a1__"